import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setAuth } from "../Components/Redux/authSlice";
import { RootState } from "../Components/Redux/store";

const UserAccount: React.FC = () => {
    const [userData, setUserData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [redirectForgot, setRedirectForgot] = useState(false);
    const auth = useSelector((state: RootState) => state.auth.value);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = getCookie('token');
                if (!token) {
                    dispatch(setAuth(false));
                    return;
                }
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const response = await axios.get('/users/user');
                setUserData(response.data.user);
                dispatch(setAuth(true));
            } catch (error) {
                dispatch(setAuth(false));
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [dispatch]);

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    if (redirectForgot) {
        return <Navigate to="/forgot" />;
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
            <div className="card shadow-lg p-4" style={{ borderRadius: "12px", maxWidth: "500px", width: "100%" }}>
                {auth ? (
                    <>
                        <h4 className="text-center mb-4" style={{ color: "#333" }}>Macluumaadka Isticmaalaha</h4>
                        {userData ? (
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item"><strong>Email-ka:</strong> {userData.email}</li>
                                <li className="list-group-item"><strong>Magaca:</strong> {userData.first_name}</li>
                                <li className="list-group-item"><strong>Magaca Aabaha:</strong> {userData.last_name}</li>
                                <li className="list-group-item"><strong>Doorka:</strong> {userData.role}</li>
                                <li className="list-group-item"><strong>Laanta:</strong> {userData.branch_name}</li>
                            </ul>
                        ) : (
                            <div className="text-center">Macluumaadka isticmaalaha lama helin</div>
                        )}
                        <div className="text-center mt-4">
                            <button
                                className="btn btn-primary"
                                style={{ padding: "10px 30px", fontWeight: "bold", fontSize: "16px" }}
                                onClick={() => setRedirectForgot(true)}
                            >
                                Cusbooneysii Macluumaadka
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="text-center">
                        <h4 style={{ color: "#555", marginTop: "20px" }}>Ma tihid mid la aqoonsaday</h4>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserAccount;
